import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Accordion, Table, Popup, Dropdown, Button, Loader, Icon} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import CompatibilityModal from '../modals/compatibilityModal';

class CarModels extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'selected': '',
      'model': '',
      'katashiki': '',
      'lastSelected': '',
      'savedModel': '',
      'savedKatashiki': '',
      'activeAccordion': false,
    };

    this.handleRepeatClick = this.handleRepeatClick.bind(this);
    this.handleSaveClick = this.handleSaveClick.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  getCarModels() {
    const {partCarModels} = this.props;

    return partCarModels.map((item, index) => ({
      'text': `${item.katashiki} | ${item.model}`,
      'value': index,
    }));
  }

  handleClick(event) {
    const {activeAccordion} = this.state;
    this.setState({'activeAccordion': !activeAccordion});
  }

  handleChange(event, data) {
    const {partCarModels} = this.props;
    const selectedModel = partCarModels[data.value] || {};

    this.setState({
      'selected': data.value,
      'katashiki': selectedModel.katashiki || '',
      'model': selectedModel.model || '',
    });
  }

  handleRepeatClick() {
    const {lastSelected, savedModel, savedKatashiki} = this.state;
    this.setState({
      'selected': lastSelected,
      'model': savedModel,
      'katashiki': savedKatashiki,
    });
  }

  handleSaveClick() {
    const {selected, model, katashiki} = this.state;
    const {partCode, franchise} = this.props;

    this.setState({
      'selected': '',
      'model': '',
      'katashiki': '',
      'lastSelected': selected,
      'savedModel': model,
      'savedKatashiki': katashiki,
    });

    this.props.savePartCarCompatibility(partCode, {
      model,
      katashiki,
      franchise,
    });
  }

  handleDeleteClick(lineNumber) {
    this.props.deletePartCarCompatibility(this.props.partCode, lineNumber);
  }

  renderLoader() {
    return (
      <Loader active inline='centered'>
        Consultando...
      </Loader>
    );
  }

  renderCompatibility() {
    const {compatibility, loadingCompatibility} = this.props;

    if (loadingCompatibility) {
      return (
        <Table.Row>
          <Table.Cell colSpan='3' textAlign='left'>
            <Loader active inline='centered'>
              Consultando...
            </Loader>
          </Table.Cell>
        </Table.Row>
      );
    }

    return compatibility.map((item) => {
      return (
        <Table.Row key={`${item.model}-${item.katashiki}`}>
          <Table.Cell textAlign='left'>{item.model}</Table.Cell>
          <Table.Cell textAlign='left'>{item.katashiki}</Table.Cell>
          <Table.Cell textAlign='left'>{item.brand}</Table.Cell>
          <Table.Cell textAlign='left'>
            <Icon
              link
              name='delete'
              color='red'
              size='large'
              onClick={this.handleDeleteClick.bind(this, item.lineNumber)}
            />
          </Table.Cell>
        </Table.Row>
      );
    });
  }

  render() {
    const {selected, model, katashiki, activeAccordion} = this.state;
    const {loadingPartCarModels} = this.props;

    return (
      <Accordion fluid styled>
        <Accordion.Title active={activeAccordion} onClick={this.handleClick}>
          <Icon name='dropdown' />
          Modelos de Vehículos
        </Accordion.Title>
        <Accordion.Content active={activeAccordion}>
          <Table striped>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>
                  <strong>Modelo</strong>
                </Table.HeaderCell>
                <Table.HeaderCell>
                  <strong>Katashiki</strong>
                </Table.HeaderCell>
                <Table.HeaderCell>
                  <strong>Marca</strong>
                </Table.HeaderCell>
                <Table.HeaderCell>
                  <strong>Acciones</strong>
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>{this.renderCompatibility()}</Table.Body>
          </Table>
          <Table>
            <Table.Body>
              <Table.Row>
                <Table.Cell textAlign='left' width='13'>
                  <Dropdown
                    fluid
                    search
                    selection
                    loading={loadingPartCarModels}
                    disabled={loadingPartCarModels}
                    value={selected}
                    options={this.getCarModels()}
                    onChange={this.handleChange}
                  />
                </Table.Cell>
                <Table.Cell textAlign='right' verticalAlign='bottom' width='3'>
                  <Popup
                    inverted
                    content='Repetir Último'
                    position='top center'
                    trigger={
                      <Button
                        circular
                        type='button'
                        color='blue'
                        icon='repeat'
                        onClick={this.handleRepeatClick}
                      />
                    }
                  />
                  <CompatibilityModal />
                  <Popup
                    inverted
                    content='Guardar'
                    position='top center'
                    trigger={
                      <Button
                        circular
                        type='button'
                        color='red'
                        icon='save'
                        onClick={this.handleSaveClick}
                        disabled={!katashiki || !model}
                      />
                    }
                  />
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </Accordion.Content>
      </Accordion>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'partCode': state.partsMaster.values.partCode,
    'franchise': state.partsMaster.values.franchise,
    'loadingPartCarModels': state.partsMaster.loadingPartCarModels,
    'partCarModels': state.partsMaster.partCarModels,
    'compatibility': state.partsMaster.compatibility,
  };
};

const {savePartCarCompatibility, deletePartCarCompatibility} = Actions;

export default connect(mapStateToProps, {savePartCarCompatibility, deletePartCarCompatibility})(CarModels);
